export default __webpack_public_path__ + "images/0d88810c37bd560269e07d211de24334.svg";